export default __webpack_public_path__ + "static/media/lock-teal.0b430244.svg";